export default function capitalizeFirstLetter(arg0: string): any {
    return String(arg0).charAt(0).toUpperCase() + String(arg0).slice(1);
}
